import * as React from "react";

export const AllCategories = (props) => (
  <svg width={38} height={38} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 1h12.696v12.696H1zM23.853 1h12.696v12.696H23.853zM1 23.853h12.696v12.696H1zM23.853 23.853h12.696v12.696H23.853z" />
    </g>
  </svg>
);

export const CropProductionInformation = (props) => (
  <svg width={40} height={37} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M7.82 7.266c0 3.461 3.41 6.266 3.41 6.266s3.42-2.805 3.42-6.266S11.23 1 11.23 1 7.82 3.806 7.82 7.266ZM8.796 11.428c2.82 2.82 2.435 7.778 2.435 7.778s-4.958.385-7.779-2.435c-2.82-2.82-2.434-7.778-2.434-7.778s4.958-.382 7.778 2.435Z"
        stroke="#5E779C"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.324 11.55c.123-.846.163-1.703.12-2.557 0 0-4.959-.382-7.779 2.435-2.82 2.816-2.434 7.778-2.434 7.778 1.115.054 2.233-.03 3.328-.25M8.796 21.682c2.82 2.82 2.435 7.776 2.435 7.776s-4.958.385-7.779-2.433c-2.82-2.818-2.434-7.778-2.434-7.778s4.958-.386 7.778 2.435Z"
        stroke="#5E779C"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.665 21.682c-2.82 2.82-2.434 7.776-2.434 7.776.842.044 1.688.007 2.523-.113M11.231 29.458V36"
        stroke="#5E779C"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(17.922 14.382)">
        <circle
          stroke="#5E779C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          cx={10.23}
          cy={10.23}
          r={10.23}
        />
        <g transform="translate(8.313 3.607)">
          <path
            d="M2.487 11.935v-5.26a.852.852 0 0 0-.853-.852H.355"
            stroke="#5E779C"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle fill="#5E779C" cx={1.544} cy={1.544} r={1.544} />
          <path
            stroke="#5E779C"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M.355 11.935h4.288"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const FarmManagement = (props) => (
  <svg width={36} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 34.275h33.342M25.644 34.275V22.678c0-.8-.649-1.45-1.45-1.45H11.149c-.801 0-1.45.65-1.45 1.45v11.597M10.221 21.657l15.423 12.618M25.176 21.611 9.698 34.275M16.221 8.794h2.9c.4 0 .725.325.725.725v5.074h-4.35V9.52c0-.4.325-.725.725-.725Z" />
      <path d="M31.443 34.275V15.43h2.174a.397.397 0 0 0 .382-.638l-4.612-8.58a.713.713 0 0 0-.335-.3L17.961 1.062a.725.725 0 0 0-.58 0L6.29 5.913a.713.713 0 0 0-.335.298l-4.611 8.58a.397.397 0 0 0 .38.639H3.9v18.845" />
    </g>
  </svg>
);

export const FertilizerRecommendation = (props) => (
  <svg width={54} height={48} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.512 28.255a.973.973 0 0 1-1.115-.811l-2.011-12.482a1.946 1.946 0 0 1 1.61-2.23l25.93-4.177 2.424-.905a1.946 1.946 0 0 1 2.602 1.513l3.577 22.206a1.946 1.946 0 0 1-1.993 2.252l-2.584-.095-18.249 2.94a.973.973 0 0 1-1.115-.812l-.618-3.842-3.84.619a.973.973 0 0 1-1.116-.812l-.619-3.84-2.883.476ZM2.518 42.9a.486.486 0 0 1 .385.57M1.948 43.284a.484.484 0 0 1 .57-.384M2.333 43.854a.484.484 0 0 1-.385-.57M2.903 43.47a.486.486 0 0 1-.57.384M8.248 44.013a.486.486 0 0 1 .385.57M7.678 44.398a.484.484 0 0 1 .57-.385M8.062 44.968a.484.484 0 0 1-.384-.57M8.633 44.584a.486.486 0 0 1-.57.384M13.978 45.127a.486.486 0 0 1 .384.57M13.407 45.512a.484.484 0 0 1 .57-.385M13.792 46.082a.484.484 0 0 1-.385-.57M14.362 45.697a.486.486 0 0 1-.57.385M7.266 38.867a.486.486 0 0 1 .385.57M6.696 39.252a.484.484 0 0 1 .57-.385M7.08 39.822a.484.484 0 0 1-.384-.57M7.65 39.438a.486.486 0 0 1-.57.384M12.996 39.981a.486.486 0 0 1 .384.57M12.426 40.366a.484.484 0 0 1 .57-.385M12.81 40.936a.484.484 0 0 1-.384-.57M13.38 40.551a.486.486 0 0 1-.57.385M12.014 34.835a.486.486 0 0 1 .385.57" />
      <path d="M11.444 35.22a.484.484 0 0 1 .57-.385M11.828 35.79a.484.484 0 0 1-.384-.57M12.399 35.406a.486.486 0 0 1-.57.384M38.273 15.422a.973.973 0 0 1 1.167 1.218c-1.014 3.604-4.033 11.754-10.39 10.518a5.732 5.732 0 0 1 2.186-11.25c2.355.311 4.748.146 7.037-.486Z" />
      <path d="M23.069 27.926a13.076 13.076 0 0 1 9.2-7.289" />
    </g>
  </svg>
);

export const Identification = (props) => (
  <svg width={39} height={39} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <path
          d="M15.362 29.361c-6.725 0-12.176-5.451-12.176-12.176C3.186-.473 24.433 8.599 34.669.109a.744.744 0 0 1 .776 0c.255.11.437.341.485.615C39.051 18.93 25.581 29.36 15.362 29.36Z"
          stroke="#5E779C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.229 13.935a40.426 40.426 0 0 0-13.923 6.937L0 26.256"
          stroke="#5E779C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle fill="#FFF" cx={21.83} cy={27.489} r={10.511} />
        <circle
          stroke="#5E779C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          cx={21.577}
          cy={27.472}
          r={6.658}
        />
        <path
          stroke="#5E779C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m31.089 36.985-4.804-4.804"
        />
      </g>
      <path
        d="M21 25.6c2.058-.495 3.582-.072 4.572 1.268"
        stroke="#5E779C"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const InputsFinance = (props) => (
  <svg width={40} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m26.209 27.667 7.172-2.381a4.469 4.469 0 0 1 4.857 1.619c-19.8 9.897-13.393 9.839-30.762 4.047L1 35" />
      <path d="M15.571 28.524h8.905a1.645 1.645 0 1 0 0-3.238H19.62a10.673 10.673 0 0 0-7.286-3.238H7.476L1 25.286M18.816 2.619c0 .894 3.624 1.62 8.095 1.62s8.095-.726 8.095-1.62c0-.894-3.624-1.619-8.095-1.619-4.47 0-8.095.725-8.095 1.619Z" />
      <path d="M35 2.619v4.857c0 .896-3.623 1.62-8.095 1.62s-8.095-.724-8.095-1.62V2.62" />
      <path d="M35 7.476v4.857c0 .896-3.623 1.62-8.095 1.62s-8.095-.724-8.095-1.62V7.476" />
      <path d="M35 12.333v4.857c0 .896-3.623 1.62-8.095 1.62s-8.095-.724-8.095-1.62v-4.857M7.483 12.333v1.619M7.483 4.238v1.619M4.245 9.095H2.626M12.34 9.095h-1.619" />
    </g>
  </svg>
);

export const KnowledgeDelivery = (props) => (
  <svg width={46} height={37} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M35.413 30.178h7.294c.896 0 1.621-.726 1.621-1.621V2.62c0-.895-.725-1.621-1.62-1.621H22.444c-.895 0-1.62.726-1.62 1.621v17.83M32.982 8.63h6.078M32.982 15.114h6.078M32.982 21.598h6.078M27.308 8.63h.811M27.308 15.114h.811M27.308 21.598h.811" />
      <path d="m22.602 28.573 6.146-2.412c1.541-.54 3.203.115 4.162 1.64-16.966 10.024-11.476 9.965-26.36 4.1L1 36" />
      <path d="M13.487 29.44h7.63c.555.118 1.116-.166 1.426-.722.31-.557.31-1.278 0-1.834-.31-.557-.87-.84-1.426-.723h-4.162c-1.644-2.006-3.882-3.18-6.243-3.28H6.55L1 26.161" />
    </g>
  </svg>
);

export const MarketInfoAccess = (props) => (
  <svg width={33} height={35} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18.6 1v13.2h13.2C31.8 6.91 25.89 1 18.6 1ZM14.2 20.8V7.6a13.2 13.2 0 1 0 8.156 23.58L14.2 20.8ZM31.8 18.6H18.6l8.156 10.38A13.18 13.18 0 0 0 31.8 18.6Z" />
    </g>
  </svg>
);

export const Pesticides = (props) => (
  <svg width={36} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22.896 14.745a4.34 4.34 0 0 1 4.34 4.34v14.468c0 .8-.647 1.447-1.446 1.447H14.215c-.799 0-1.447-.648-1.447-1.447V19.085a4.34 4.34 0 0 1 4.34-4.34h5.788Z" />
      <path d="M22.896 11.851h4.109c1.356 0 2.53.942 2.824 2.266l1.502 6.756a1.413 1.413 0 0 0 2.758-.613l-1.505-6.771a5.787 5.787 0 0 0-5.65-4.532h-6.932" />
      <path d="M17.109 14.745V11.85a2.894 2.894 0 1 1 5.787 0v2.894M20.002 1.723v7.234M13.49 1.723h9.406" />
      <path d="m17.109 12.574-5.154-.643a.723.723 0 0 1-.633-.724v-.888a.723.723 0 0 1 .633-.724l5.154-.638h2.893M5.521 7.149c.2 0 .362.162.362.362M5.16 7.51c0-.2.162-.361.361-.361M5.521 7.872a.362.362 0 0 1-.361-.361" />
      <path d="M5.883 7.51c0 .2-.162.362-.362.362M5.521 11.49c.2 0 .362.161.362.361M5.16 11.851c0-.2.162-.362.361-.362" />
      <path d="M5.521 12.213a.362.362 0 0 1-.361-.362M5.883 11.851c0 .2-.162.362-.362.362M1.904 4.979c.2 0 .362.162.362.361M1.543 5.34c0-.2.161-.361.361-.361M1.904 5.702a.362.362 0 0 1-.361-.362M2.266 5.34c0 .2-.162.362-.362.362M1.904 9.32c.2 0 .362.161.362.36M1.543 9.68c0-.199.161-.36.361-.36M1.904 10.043a.362.362 0 0 1-.361-.362M2.266 9.68c0 .2-.162.363-.362.363M1.904 13.66c.2 0 .362.162.362.361M1.543 14.021c0-.2.161-.361.361-.361" />
      <path d="M1.904 14.383a.362.362 0 0 1-.361-.362M2.266 14.021c0 .2-.162.362-.362.362" />
    </g>
  </svg>
);

export const Scouting = (props) => (
  <svg width={36} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#5E779C"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M34.968 19.035a1.478 1.478 0 0 0-.31-1.227 1.478 1.478 0 0 0-1.138-.547H15.337a1.478 1.478 0 0 1-1.478-1.183l-.384-2.07a1.478 1.478 0 0 0-1.479-1.182h-9.52c-.442.003-.86.204-1.138.547a1.478 1.478 0 0 0-.31 1.227L4.87 33.817c.143.7.765 1.197 1.479 1.183h24.213a1.478 1.478 0 0 0 1.479-1.183c.576-3.06 2.217-11.175 2.926-14.782ZM8.39 9.87V2.477C8.39 1.662 9.05 1 9.868 1h19.217c.816 0 1.478.662 1.478 1.478v11.826M12.824 5.435h12.565M18.737 9.869h6.652" />
    </g>
  </svg>
);

export const FilterClearIcon = (props) => (
  <svg
    height="20"
    width="20"
    viewBox="0 0 20 20"
    aria-hidden="true"
    focusable="false"
    className="css-tj5bde-Svg"
  >
    <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
  </svg>
);

export const FilterIcon = (props) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"setup-preferences"}</title>
    <g
      transform="translate(1 1)"
      stroke="#348635"
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13 3h9M0 3h3M21 11h1M0 11h11M13 19h9M0 19h3" />
      <circle cx={6} cy={3} r={3} />
      <circle cx={14} cy={11} r={3} />
      <circle cx={6} cy={19} r={3} />
    </g>
  </svg>
);

export const NoResultIcon = (props) => (
  <svg width={110} height={84} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(0 2)" fill="none" fillRule="evenodd">
      <g
        transform="translate(52.577)"
        stroke="#000D1C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3.5}
      >
        <ellipse
          fill="#F7F8FA"
          cx={27.511}
          cy={27.287}
          rx={27.511}
          ry={27.287}
        />
        <path d="M37.762 26.53c.507 0 .918.408.918.91s-.411.91-.918.91a.913.913 0 0 1-.917-.91c0-.241.096-.473.268-.644a.918.918 0 0 1 .65-.265m-19.3-.001c.507 0 .917.408.917.91s-.41.91-.917.91a.913.913 0 0 1-.917-.91c0-.502.41-.91.917-.91m1.123-12.957a8.349 8.349 0 0 0-5.464.675 8.266 8.266 0 0 0-3.937 3.822m27.076 20.88a6.81 6.81 0 0 0-7.943 1.99m6.119-23.864c3.792-.764 7.634 1.07 9.4 4.485" />
      </g>
      <path
        fill="#F7F8FA"
        d="M50.593 20.621 74.7 34.988 63.993 52.66 39.887 38.294z"
      />
      <rect fill="#FFDEDE" y={10.915} width={51.354} height={50.936} rx={23} />
      <path
        d="M60.641 45.023c.001 8.891-5.398 16.908-13.68 20.311-8.282 3.403-17.815 1.523-24.154-4.765-6.34-6.287-8.235-15.743-4.804-23.957 3.43-8.215 11.513-13.57 20.478-13.57a22.253 22.253 0 0 1 15.67 6.438 21.89 21.89 0 0 1 6.49 15.543zM33.013 39.415 46.13 52.426m-13.117 0L46.13 39.415"
        stroke="#C70000"
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m53.173 62.946 1.276-1.223a2.243 2.243 0 0 1 1.596-.625c.572.01 1.142.238 1.572.68l11.407 11.716c.433.445.645 1.024.638 1.6a2.239 2.239 0 0 1-.675 1.577l-1.278 1.223a2.243 2.243 0 0 1-1.595.625 2.243 2.243 0 0 1-1.573-.68L53.134 66.123a2.243 2.243 0 0 1-.637-1.6 2.243 2.243 0 0 1 .676-1.577z"
        stroke="#C70000"
        strokeWidth={3.5}
      />
    </g>
  </svg>
)

